// extracted by mini-css-extract-plugin
module.exports = {"dropdown-menu-wrapper":"_3RCAdsyUiIyL3O6zv5mBWn","is-child-dom":"_1u1ZnmR1I_kW-eE6q_Qoly","triangle-arrow":"_3jBVSyydrE7l0GAAsJChfz"};